"use strict";
const FEWTOKEN_CREATE_PATH = "/positions/create/fewtoken";
export const FEWTOKEN_MAINTENANCE_PATH = "/positions/maintain/fewtoken";
function addRecoveryContext(params, recoveryContext) {
  if (recoveryContext?.chain) {
    params.set("chain", recoveryContext.chain);
  }
  if (recoveryContext?.pairAddress) {
    params.set("pairAddress", recoveryContext.pairAddress);
  }
}
function appendParams(path, params) {
  const query = params.toString();
  return query ? `${path}?${query}` : path;
}
export function buildMaintenanceEntryPath(context = {}) {
  const params = new URLSearchParams();
  if (context.maintenanceId) {
    params.set("maintenanceId", context.maintenanceId);
  }
  addRecoveryContext(params, context);
  if (context.liquidityComplete) {
    params.set("liquidityComplete", "1");
  }
  return appendParams(FEWTOKEN_MAINTENANCE_PATH, params);
}
export function buildMaintenanceLiquidityPath(maintenanceId, recoveryContext) {
  const params = new URLSearchParams({ tool: "liquidity", maintenanceId });
  addRecoveryContext(params, recoveryContext);
  return appendParams(FEWTOKEN_CREATE_PATH, params);
}
export function buildMaintenanceAdjustPricePath(maintenanceId, liquidityComplete = false, recoveryContext) {
  return buildMaintenanceEntryPath({ maintenanceId, liquidityComplete, ...recoveryContext });
}
export function isAllowedMaintenanceReturnTo(returnTo) {
  if (!returnTo?.startsWith("/") || returnTo.startsWith("//")) {
    return false;
  }
  try {
    const parsed = new URL(returnTo, "https://app.ring.exchange");
    if (parsed.origin !== "https://app.ring.exchange") {
      return false;
    }
    if (parsed.pathname === FEWTOKEN_MAINTENANCE_PATH) {
      return true;
    }
    return parsed.pathname === FEWTOKEN_CREATE_PATH && parsed.searchParams.get("tool") === "adjust-price";
  } catch {
    return false;
  }
}
